export const selectMultiple = {
  default: "Please select all that apply.",
  gr: "Επιλέξτε όσα ισχύουν",
  fr: "Veuillez cocher les cases correspondantes",
  de: "",
  ka: "გთხოვთ, აირჩიოთ ყველაფერი, რაც ეხება.",
  fi: "Valitse kaikki jotka sopivat",
}